import { render, staticRenderFns } from "./Wemedia.vue?vue&type=template&id=0f81252a&scoped=true&"
import script from "./Wemedia.vue?vue&type=script&lang=js&"
export * from "./Wemedia.vue?vue&type=script&lang=js&"
import style0 from "./Wemedia.vue?vue&type=style&index=0&id=0f81252a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81252a",
  null
  
)

export default component.exports